import { Component, ViewEncapsulation, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'toolbox-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CardComponent {;
  @Input() title: string;
  @Input() myclass: string;
}



// WEBPACK FOOTER //
// C:/dev/Perso/urmeo/src/app/toolbox/card/card.component.ts